import React from 'react';
import { useDispatch } from 'react-redux';
import { LocationOn, Search } from '@mui/icons-material';
import {
    Box,
    Paper,
    Grid2,
    Button,
    TextField,
    Autocomplete,
    InputAdornment,
    CircularProgress
} from '@mui/material';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import GooglePoweredLogo from '../../../../../../../../components/EventDetails/venue-location/GooglePoweredLogo';
import EmbedMap from '../../../../../../../../components/maps/EmbedMap/EmbedMap';
import JavascriptMap from '../../../../../../../../components/maps/JsMap/JavascriptMap';
import RedirectToTicket from '../../../../../../../../components/Dialog/RedirectToTicket';
import AlertDialog from '../../../../../../../../components/Dialog/AlertDialog';
import { previousTab } from '../../../../../../../../app/store/slices/event/event';
import useCustomLocation from '../../../hooks/useCustomLocation';
import { Body3, Body2, Body1 } from '../../../../../../../../themes/typography';
import '../../../../../../../../styles/components/VenueBooking.css';
import '../../../../../../../../styles/components/CustomLocation.css';

export default function CustomLocation() {
    const {
        loading,
        formik,
        isEditModeOn,
        googleSuggestOption,
        setMapDragData,
        handleFieldInputChange,
        setGoogleSelectedValue,
        googleSelectedValue,
        handleTicketRedirect,
        openTicketPopup,
        handleSkipForNow,
        openLocationSkipModal,
        setOpenLocationSkipModal,
        isDiffMoreThan24Hours,
        shouldShowEditButton,
        setIsEditModeOn
        // disabledFields
    } = useCustomLocation();
    const dispatch = useDispatch();

    return (
        <React.Fragment>
            <form className="custom-location-form" noValidate onSubmit={formik.handleSubmit}>
                <div className="venue-booking-container">
                    <div className="venue-booking-main-container">
                        {shouldShowEditButton && (
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    alignItems: 'flex-start'
                                }}
                            >
                                <Button
                                    startIcon={<BorderColorIcon />}
                                    variant="text"
                                    onClick={() => setIsEditModeOn(true)}
                                    disabled={isEditModeOn}
                                >
                                    Edit
                                </Button>
                            </Box>
                        )}

                        <div className="custom-location-container">
                            <div className="custom-location-main-container">
                                <div className="custom-location-body-container">
                                    <div className="venue-select-dropdown-container">
                                        <Autocomplete
                                            id="venue-custom-location"
                                            fullWidth
                                            multiple={false}
                                            clearOnBlur={false}
                                            disabled={!isEditModeOn}
                                            disableCloseOnSelect={false}
                                            options={googleSuggestOption}
                                            onInputChange={(event, newInputValue) => {
                                                formik.setFieldValue(
                                                    'searchedVenue',
                                                    newInputValue
                                                );
                                            }}
                                            onChange={(event, newValue) => {
                                                formik.setFieldValue(
                                                    'searchedVenue',
                                                    newValue?.secondaryText
                                                );
                                                setGoogleSelectedValue(newValue);
                                            }}
                                            getOptionLabel={(option) =>
                                                `${option?.venueName} ${option?.address}`
                                            }
                                            renderOption={(props, option) => {
                                                const { key, ...optionProps } = props;
                                                return (
                                                    <li {...optionProps} key={option?.place_id}>
                                                        <Grid2 container alignItems="center">
                                                            <Grid2
                                                                sx={{
                                                                    display: 'flex',
                                                                    width: 44
                                                                }}
                                                            >
                                                                <LocationOn
                                                                    sx={{ color: '#26c1e8' }}
                                                                />
                                                            </Grid2>
                                                            <Grid2
                                                                sx={{
                                                                    width: 'calc(100% - 44px)'
                                                                }}
                                                            >
                                                                <Body2 color="#11203a">
                                                                    {option?.venueName}
                                                                </Body2>
                                                                <Body3 color="#212121">
                                                                    {option?.address}
                                                                </Body3>
                                                            </Grid2>
                                                        </Grid2>
                                                    </li>
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        startAdornment: (
                                                            <React.Fragment>
                                                                <SearchAdorment />
                                                            </React.Fragment>
                                                        )
                                                    }}
                                                    // autoFocus
                                                    label="Enter venue name or nearest location"
                                                    placeholder="Enter venue name or nearest location"
                                                    error={
                                                        formik.touched.selectedVenues &&
                                                        Boolean(formik.errors.selectedVenues)
                                                    }
                                                    helperText={
                                                        formik.touched.selectedVenues &&
                                                        formik.errors.selectedVenues
                                                    }
                                                />
                                            )}
                                            slotProps={{
                                                paper: {
                                                    sx: paper2Style
                                                }
                                            }}
                                            ListboxComponent={(listboxProps) => {
                                                const { children, ...other } = listboxProps;

                                                return (
                                                    <Paper elevation={8} sx={paperStyle}>
                                                        <ul {...other} style={ulStyle}>
                                                            {children}
                                                        </ul>
                                                        <Box
                                                            sx={{
                                                                ...fixedButtonStyle,
                                                                justifyContent: 'flex-end'
                                                            }}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <GooglePoweredLogo />
                                                        </Box>
                                                    </Paper>
                                                );
                                            }}
                                        />
                                    </div>

                                    {/* {(isDiffMoreThan24Hours && formik.values.venueName === '') && ( */}
                                    {isDiffMoreThan24Hours && (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'flex-start'
                                            }}
                                        >
                                            <div
                                                className="venue-is-not-decided-container"
                                                onClick={() => setOpenLocationSkipModal(true)}
                                            >
                                                <LocationOn
                                                    sx={{
                                                        color: '#26c1e8',
                                                        fontSize: '1.25rem'
                                                    }}
                                                />
                                                <Body3>My venue is not decided</Body3>
                                            </div>
                                        </Box>
                                    )}

                                    <div className="custom-location-search-bar-details">
                                        <div className="left-side-search-bar-details">
                                            <div className="venue-address-input-container">
                                                <TextField
                                                    required
                                                    id="venue-name"
                                                    name="venueName"
                                                    label="Venue Name"
                                                    fullWidth={true}
                                                    disabled={!isEditModeOn}
                                                    value={formik.values.venueName}
                                                    onChange={handleFieldInputChange}
                                                    error={
                                                        formik.touched.venueName &&
                                                        Boolean(formik.errors.venueName)
                                                    }
                                                    helperText={
                                                        formik.touched.venueName &&
                                                        formik.errors.venueName
                                                    }
                                                />
                                            </div>

                                            <div className="venue-address-input-container">
                                                <TextField
                                                    required
                                                    id="address"
                                                    name="address"
                                                    label="Address"
                                                    fullWidth={true}
                                                    disabled={!isEditModeOn}
                                                    value={formik.values.address}
                                                    onChange={handleFieldInputChange}
                                                    error={
                                                        formik.touched.address &&
                                                        Boolean(formik.errors.address)
                                                    }
                                                    helperText={
                                                        formik.touched.address &&
                                                        formik.errors.address
                                                    }
                                                />
                                            </div>

                                            <div className="venue-input-containers">
                                                <div className="right-side-venue-input-container">
                                                    <TextField
                                                        id="street"
                                                        label="Street"
                                                        name="street"
                                                        disabled
                                                        fullWidth={true}
                                                        value={formik.values.street}
                                                        onChange={handleFieldInputChange}
                                                        error={
                                                            formik.touched.street &&
                                                            Boolean(formik.errors.street)
                                                        }
                                                        helperText={
                                                            formik.touched.street &&
                                                            formik.errors.street
                                                        }
                                                    />
                                                </div>
                                                <div className="left-side-venue-input-container">
                                                    <TextField
                                                        id="area"
                                                        label="Area"
                                                        name="area"
                                                        disabled
                                                        fullWidth={true}
                                                        value={formik.values.area}
                                                        onChange={handleFieldInputChange}
                                                        error={
                                                            formik.touched.area &&
                                                            Boolean(formik.errors.area)
                                                        }
                                                        helperText={
                                                            formik.touched.area &&
                                                            formik.errors.area
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div className="venue-input-containers">
                                                <div className="left-side-venue-input-container">
                                                    <TextField
                                                        id="city"
                                                        label="City"
                                                        name="city"
                                                        fullWidth={true}
                                                        disabled
                                                        value={formik.values.city}
                                                        onChange={handleFieldInputChange}
                                                        error={
                                                            formik.touched.city &&
                                                            Boolean(formik.errors.city)
                                                        }
                                                        helperText={
                                                            formik.touched.city &&
                                                            formik.errors.city
                                                        }
                                                    />
                                                </div>
                                                <div className="right-side-venue-input-container">
                                                    <TextField
                                                        id="state"
                                                        label="State"
                                                        name="state"
                                                        fullWidth={true}
                                                        disabled
                                                        value={formik.values.state}
                                                        onChange={handleFieldInputChange}
                                                        error={
                                                            formik.touched.state &&
                                                            Boolean(formik.errors.state)
                                                        }
                                                        helperText={
                                                            formik.touched.state &&
                                                            formik.errors.state
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div className="venue-input-containers">
                                                <div className="left-side-venue-input-container">
                                                    <TextField
                                                        id="postal-code"
                                                        label="Postal Code"
                                                        name="postalCode"
                                                        disabled
                                                        fullWidth={true}
                                                        value={formik.values.postalCode}
                                                        onChange={handleFieldInputChange}
                                                        error={
                                                            formik.touched.postalCode &&
                                                            Boolean(formik.errors.postalCode)
                                                        }
                                                        helperText={
                                                            formik.touched.postalCode &&
                                                            formik.errors.postalCode
                                                        }
                                                    />
                                                </div>
                                                <div className="right-side-venue-input-container"></div>
                                            </div>
                                        </div>

                                        <div className="right-side-search-bar-details">
                                            <div className="right-side-google-map-container">
                                                {googleSelectedValue != null ? (
                                                    <JavascriptMap
                                                        values={googleSelectedValue}
                                                        setMarkerDraggedLocation={setMapDragData}
                                                    />
                                                ) : (
                                                    <EmbedMap />
                                                )}
                                            </div>
                                            <div className="right-side-drag-and-drop-container">
                                                <LocationOn
                                                    style={{
                                                        color: '#26c1e8',
                                                        fontSize: '1.25rem'
                                                    }}
                                                />
                                                <Body3>
                                                    Drag and drop marker to adjust location
                                                </Body3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="submit-button-container">
                    <Button variant="text" onClick={() => dispatch(previousTab())}>
                        Back to Media
                    </Button>
                    <Button variant="main" disabled={loading} type="submit">
                        {/* {isEditModeOn ? 'Save' : 'Next'} */}
                        Next{' '}
                        {loading && (
                            <CircularProgress
                                size={20}
                                sx={{ marginLeft: '0.75rem', color: 'var(--primary-color)' }}
                            />
                        )}
                    </Button>
                </div>
            </form>

            <RedirectToTicket
                open={openTicketPopup}
                onClose={handleSkipForNow}
                onClick={handleTicketRedirect}
            />
            <AlertDialog
                open={openLocationSkipModal}
                onCancel={() => setOpenLocationSkipModal(false)}
                onConfirm={handleTicketRedirect}
                dialogTitle="Skip Venue Location?"
                primaryBtnName="Create Tickets"
                secondaryBtnName="Skip for now"
            >
                <ul className="ticket-creation-notes">
                    <li>
                        <Body1>Continue by creating tickets for this event to make it live.</Body1>
                    </li>
                    <li>
                        <Body1>Skip it for now and create tickets later when you are ready.</Body1>
                    </li>
                </ul>
            </AlertDialog>
        </React.Fragment>
    );
}

// Function to show search icon in input
function SearchAdorment() {
    return (
        <InputAdornment position="start">
            <Search />
        </InputAdornment>
    );
}

const fixedButtonStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5rem 1rem',
    position: 'sticky',
    bottom: 0,
    zIndex: 1
};

const ulStyle = {
    maxHeight: 250,
    overflow: 'auto',
    margin: 0,
    padding: '8px 0',
    listStyle: 'none'
};

const paperStyle = {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
};

const paper2Style = {
    width: '1150px',
    borderRadius: '0 0 15px 15px',
    marginLeft: '15px',
    '& .MuiAutocomplete-option': {
        color: '#11203a'
    }
};
